import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { formatDate } from '@/shared/utils/date-utils';
import i18n from '@/i18n';

interface GoalCardDatesProps {
  startDate?: string;
  dueDate?: string;
}

export const GoalCardDates: React.FC<GoalCardDatesProps> = ({
  startDate,
  dueDate,
}) => {
  const { t } = useTranslation('goals');
  if (!startDate && !dueDate) {
    return null;
  }

  return (
    <div className="mt-3 ms-9 flex items-center gap-4 text-xs text-gray-500">
      {startDate && (
        <div className="flex items-center gap-1.5">
          <Calendar className="h-3.5 w-3.5" />
          <span className="font-medium">{t('startDateLabel')}:</span>
          <span>{formatDate(startDate, 'MMM d, yyyy', i18n.language)}</span>
        </div>
      )}
      {dueDate && (
        <div className="flex items-center gap-1.5">
          <Calendar className="h-3.5 w-3.5" />
          <span className="font-medium">{t('dueDateLabel')}:</span>
          <span>{formatDate(dueDate, 'MMM d, yyyy', i18n.language)}</span>
        </div>
      )}
    </div>
  );
};
